/*
    This file defines experiment specific behaviours.
*/
(function() {

  document.addEventListener('cart:rerender', function() {
    var exp_manager = window.ExperimentManager;
    var exp_bucket = exp_manager.getBucketForUser('pair_with_upselling_experiment');
    var smallMobileDeviceRule = window.matchMedia('(min-height: 600px)');
    if (exp_bucket == 'showvp') {
      var upsellingProductsVp = document.querySelectorAll('div[data-upselling-bucket-name="pairwith-products-vp"]');
      if (upsellingProductsVp.length != 0) {
        upsellingProductsVp.forEach(function(node) {
          var cartItems = parseInt(node.getAttribute('data-cart-items'));
          if (cartItems < 2 || (cartItems == 2 && smallMobileDeviceRule.matches)) {
            node.style.display = 'block';
          }
        });
      }
    } else if (exp_bucket == 'showpp') {
      var upsellingProductsPp = document.querySelectorAll('div[data-upselling-bucket-name="pairwith-products-pp"]');
      if (upsellingProductsPp.length != 0) {
        upsellingProductsPp.forEach(function(node) {
          var cartItems = parseInt(node.getAttribute('data-cart-items'));
          if (cartItems < 2 || (cartItems == 2 && smallMobileDeviceRule.matches)) {
            node.style.display = 'block';
          }
        });
      }
    }
  });

   // Below is to handle experiment changes that require wait on dom content load.
  document.addEventListener('DOMContentLoaded', function() {
    var counter = 0;
    applyExperimentsAfterDOMLoad();
    var expLoop = setInterval(function() {
      applyExperimentsAfterDOMLoad();
      counter = counter + 1;
      if (counter > 15) {
        clearInterval(expLoop);
      }
    }, 500);
  });

  function applyExperimentsAfterDOMLoad() {
    var experimentManager = window.ExperimentManager;
    for (var i = 0; i < experimentManager.experimentList.length; i++) {
      var expName = experimentList[i].name;
      if (expName == 'pair_with_upselling_experiment') {
        document.dispatchEvent(new CustomEvent('cart:rerender'));
      }
    }
  }
  
  function removeExtraPricePropertyFromCart() {
    var cartPropertyNodes = document.querySelectorAll('.CartItem__Property');
    for (var i = 0; i < cartPropertyNodes.length; i++) {
      var node = cartPropertyNodes[i];
      if (node.textContent.indexOf('ovpd:') != -1) {
        node.remove();
      }
    }
  }
  
  function applyVariablePriceExperiment() {
    // Updating product page prices based on user bucket
    var bucketIndex = ExperimentManager.getBucketIndexForUser('shirt_price_experiment');
    updatePriceForExperiment(bucketIndex, 40);
  }

  function updatePriceForExperiment(bucketIndex, intervalTime) {
    updatePriceAtAllPlacesForBucketIndex(bucketIndex);
    intervalTime = intervalTime * 2;
    if (intervalTime > 200) {
      // After reaching to 200 ms using setInterval instead of setTimeout.
      setInterval(function() {
        updatePriceAtAllPlacesForBucketIndex(bucketIndex);
      }, 200);
      return;
    }
    // Using set timeout as we need to apply pricing update as soon as possible, hence on page load have lower interval time and then increasing it till 200ms.
    setTimeout(function() {
      updatePriceForExperiment(bucketIndex, intervalTime);
    }, intervalTime);
  }

  function updatePriceAtAllPlacesForBucketIndex(bucketIndex) {
    removeExtraPricePropertyFromCart();
    updateProductPageTitlePrice(bucketIndex);
    updateProductPageSwatchPrice(bucketIndex);
    updateCollectionProductTitlePrice(bucketIndex);
    updateComparisonPrice(bucketIndex);
    updatePairWithPrice(bucketIndex);
    updatePDPDiscountSection(bucketIndex);
  }
  
  function updatePDPDiscountSection(bucketIndex) {

    // For control and plus4 bucket keeping the discount, else removing.
    if (bucketIndex === 0 || bucketIndex === 3) {
      return;
    }

    // Check if PDP page, if yes then remove bulk up discount offer.
    if (window.location.pathname.indexOf('products/') !== -1) {
      var productJSONNode = document.querySelector('script[data-product-json]');
      if (!productJSONNode) {
        return;
      }
      var productId = JSON.parse(productJSONNode.innerText).product.id;
      // Note: Intentionally hardcoding for only 4 products on which this experiment is getting applied.
      if ([4368846913647, 4368901242991, 4368904159343, 4368903503983].indexOf(parseInt(productId)) !== -1) {
        var productFormOfferNodes = document.querySelectorAll('#lb-discount-section');
        for (var i = 0; i < productFormOfferNodes.length; i++) {
          var node = productFormOfferNodes[i];
          node.remove();
        }
      }
    }
  }


  function updatePairWithPrice(variablePriceIndex) {
    var optionNodes = document.querySelectorAll('.RelatedVariantItem__MainContainer option');
    for (var i = 0; i < optionNodes.length; i++) {
      var node = optionNodes[i];
      var variablePricingDiff = node.getAttribute('data-variable-pricing-diff');
      if (variablePricingDiff != undefined) {
        var priceDiff = variablePricingDiff.split(',')[variablePriceIndex];
        var originalPrice = node.getAttribute('data-original-price');
        var updatedPrice = (parseInt(originalPrice) - parseInt(priceDiff)) / 100;
        var currentSetPrice = node.getAttribute('data-variant-price');
        if (currentSetPrice != '$' + updatedPrice) {
          node.setAttribute('data-variant-price', '$' + updatedPrice);
          var evt = document.createEvent('HTMLEvents');
          evt.initEvent('change', false, true);
          node.parentElement.dispatchEvent(evt);
        }
      }
    }
  }

  function updateComparisonPrice(variablePriceIndex) {
    updateVariablePriceOnNodes(document.querySelectorAll('.ProductComparison__LBPrice'), variablePriceIndex);
  }

  function updateCollectionProductTitlePrice(variablePriceIndex) {
    updateVariablePriceOnNodes(document.querySelectorAll('.ProductItem__InlinePrice'), variablePriceIndex);
  }

  function updateProductPageTitlePrice(variablePriceIndex) {
    updateVariablePriceOnNodes(document.querySelectorAll('.Product_InlinePrice'), variablePriceIndex);
  }

  function updateProductPageSwatchPrice(variablePriceIndex) {
    updateVariablePriceOnNodes(document.querySelectorAll('.SizeSwatch'), variablePriceIndex);
  }

  function updateVariablePriceOnNodes(inputNodes, variablePriceIndex) {
    for (var i = 0; i < inputNodes.length; i++) {
      var node = inputNodes[i];
      var variablePricingDiff = node.getAttribute('data-variable-pricing-diff');
      if (variablePricingDiff != undefined) {
        var priceDiff = variablePricingDiff.split(',')[variablePriceIndex];
        var originalPrice = node.getAttribute('data-original-price');
        var updatedPrice = (parseInt(originalPrice) - parseInt(priceDiff)) / 100;
        var curTextContentSplit = node.textContent.split('$');
        curTextContentSplit[1] = updatedPrice + ' ';
        node.textContent = curTextContentSplit.join('$');
      }
    }
  }

  // Doing outside generic loop as it requires tight timeout interval
  applyVariablePriceExperiment();
})();

